import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import interceptors from './api/interceptors'
import { DatePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft, faCog, faCheckCircle, faUmbrella, faHandHoldingUsd, faExclamationCircle, faFileInvoice, faPercent, faUnlock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vSelect from 'vue-select'
import VueMarkdown from 'vue-markdown'

import * as Sentry from '@sentry/browser'

Vue.config.productionTip = false

// Fontawesome icons
library.add(faChevronLeft, faCog, faCheckCircle, faUmbrella, faHandHoldingUsd, faExclamationCircle, faFileInvoice, faPercent, faUnlock)
Vue.component('icon', FontAwesomeIcon)

// Datepicker
locale.use(lang)
Vue.use(DatePicker)

// Axios interceptors (executed before or after every request)
interceptors()

// Vue-select autocomplete dropdown
Vue.component('v-select', vSelect)

Vue.filter('currency', function (value) {
  var formatter = new Intl.NumberFormat('en-UK', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2
  })
  return formatter.format(Number(value))
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// Sentry
Sentry.init({
  dsn: 'https://13786b15fbba40a698c7debd136e89fc@sentry.io/1418962',
  integrations: [new Sentry.Integrations.Vue({
    Vue,
    attachProps: true
  })]
})

// Markdown
Vue.component('VueMarkdown', VueMarkdown)
